import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getColor, Theme } from 'styles/theme';

export const PageWrapper = styled.div`

  nav:first-child {
    margin-left: 16px;

    @media (${breakpoint.lgMin}) {
      margin-left: 0;
    }
  }

  @media (${breakpoint.lgMax}) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;

  .search {
    justify-content: flex-end;
  }

  @media (${breakpoint.mmMin}) {
    .heading {
      margin-right: 40px;
    }
  }

  @media (${breakpoint.lgMax}) {
    flex-direction: column;
    align-items: stretch;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const Wrapper = styled.div`
  .mobile-search {
    display: block;
    input {
      width: 70%;
    }

    .search-button {
      width: 30%;
    }
  }
  @media (${breakpoint.mdMin}) {
    .crash-course-filters{
      width: 40%;
    }
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
  }
`;

export const SelectedFiltersWrappers = styled.div<{ theme: Theme }>`
  display: flex;
  gap: 24px;
  height: 40px;
  align-items: center;

  .selected-filter {
    display: flex;
    font-family: ${font.graphikCond};
    font-size: 16px;
    font-weight: 400;
    padding: 4px 8px;
    line-height: 24px;
    letter-spacing: 0.5px;
    flex-direction: row-reverse;
    text-transform: capitalize;
    background-color: ${getColor('shadeBrandPrimary100')};

    .close {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 4px;
      margin-top: 2px;
      
      ${getIcon('svg-states')};

      &::before {
        ${getIcon('close-icon', { height: 12, width: 12 })};
        background-color: ${getColor('neutralBlack')};
      }
    }
  }

`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (${breakpoint.mdMin}) {
    margin-top: 48px;
  }
`;

export const SidebarWrapper = styled.div`
  margin-right: 24px;
  position: relative;

  & > div:nth-child(2) {
    margin-top: 16px;
  }
`;

export const Sidebar = styled.div`
  position: sticky;
  top: 90px;
  margin-bottom: 90px;
`;

export const AdContainer = styled.div`
  & > div > div {
    top: 40px;
  }
`;

export const ScreenReader = styled.p`
  color: transparent;
  height: 0.1px;
  width: 0.1px;
`;
